"use client";

import { RotateCcw } from "lucide-react";

import { BackendUnavailableState } from "@/components/app/backend-unavailable-state";
import { Button } from "@/components/ui/button";

export default function SafetyError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <BackendUnavailableState
      action={
        <Button onClick={reset} variant="secondary">
          <RotateCcw aria-hidden="true" className="size-4" />
          Retry
        </Button>
      }
      eyebrow="Safety"
    />
  );
}
